export const HOME_BANNER_DESKTOP = 'home-banner-desktop';
export const HOME_BANNER_DESKTOP_SELL = 'home-banner-desktop-sell';
export const CARS_CATEGORY_BANNER_DESKTOP_SELL = 'cars-category-banner-desktop-sell';
export const CALL_CUSTOMER_CARE_BANNER_DESKTOP = 'call-customer-care-banner-desktop';
export const CALL_CUSTOMER_CARE_BANNER_MOBILE = 'call-customer-care-banner-mobile';
